stickerMargin = require 'data/sticker-margin'

minValue = -stickerMargin
maxValue = 100 - stickerMargin

# Used to ensure that a sticker is inside the editable area
module.exports = (value) ->
  if value < minValue
    minValue
  else if value > maxValue
    maxValue
  else
    value



// WEBPACK FOOTER //
// ./app/scripts/lib/util/sticker-clip.coffee